import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { selectActiveBuilding } from '../../../reducers/buildingSelectorReducer'
import { selectUserData } from '../../../reducers/userDataReducer'
import ReservationsList from '../ReservationsList/ReservationsList'
import ReservationsAnalytics from '../ReservationsAnalytics/ReservationsAnalytics'

const ReservationsBookings = ({ userData, building }) => (
  <div className="reservations-bookings">
    <div className="reservations-bookings__wrapper">
      <ReservationsAnalytics building={building || userData.buildingId} />
    </div>
    <div className="reservations-bookings__wrapper">
      <ReservationsList building={building || userData.buildingId} />
    </div>
  </div>
)

ReservationsBookings.propTypes = {
  userData: PropTypes.object,
  building: PropTypes.object,
}

export default connect((state) => ({
  userData: selectUserData(state),
  building: selectActiveBuilding(state),
}))(ReservationsBookings)
